import React, { useEffect, useState } from "react";
import { api } from "../api";
import { useNavigate } from "react-router-dom";

const DrawingMaster = () => {
  const [drawingList, setDrawingList] = useState([]);
  const [typeofProject, settypeofProject] = useState("");
  const [workType, setworkType] = useState("");
  const [drawingDocument, setdrawingDocument] = useState("");
  const [estimatedHours, setEstimatedHours] = useState("");
  const [timeUnit, setTimeUnit] = useState("hrs");
  const [category, setCategory] = useState("ALL");
  const [viewCategory, setViewCategory] = useState("ALL"); // 🔥 Added filter state
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const navigate = useNavigate();

  const SHEET_ID = "1TxXRKfzwY8CMQ8FNYdLb63lezNH8ilyoiRVWrkKoH2I";
  const API_KEY = "AIzaSyA5lIGwtgEOJkpUljdV9BeK_-e_foGvI00";
  const RANGE = "Sheet1";

  useEffect(() => {
    fetchDrawingList();
  }, []);

  const fetchGoogleSheetData = async () => {
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`;
    const res = await fetch(url);
    const json = await res.json();

    if (!json.values || json.values.length === 0) return [];

    const [headers, ...rows] = json.values;
    return rows.map((row) =>
      Object.fromEntries(headers.map((h, i) => [h.trim(), row[i] || ""]))
    );
  };

  const fetchDrawingList = async () => {
    setLoading(true);
    try {
      const [apiRes, sheetRes] = await Promise.all([
        api.get("/drawing-master", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        fetchGoogleSheetData(),
      ]);

      const sheetData = sheetRes
        .filter((row) => row["Drawings & Documents"])
        .map((row, index) => ({
          typeofProject: row["Type of Project"] || "",
          workType: row["Work type"] || "",
          drawingDocument: row["Drawings & Documents"] || "",
          estimatedHours: row["Estimate Mins"]
            ? (parseFloat(row["Estimate Mins"]) / 60).toFixed(2)
            : "",
          category: row["Category"] || "",
          _id: `sheet-${index}`,
          source: "sheet",
        }));

      setDrawingList([...apiRes.data, ...sheetData]);
    } catch (err) {
      alert("❌ Error fetching data from backend or sheet.");
    }
    setLoading(false);
  };

  const handleAddDrawingMaster = async () => {
    if (!drawingDocument.trim()) {
      alert("Drawing & Document is required.");
      return;
    }
    if (!estimatedHours || parseFloat(estimatedHours) < 0) {
      alert("Estimated hours must be ≥ 0.");
      return;
    }

    try {
      const convertedHours =
        timeUnit === "min"
          ? (parseFloat(estimatedHours) / 60).toFixed(2)
          : parseFloat(estimatedHours);

      const payload = {
        typeofProject,
        workType,
        drawingDocument,
        estimatedHours: convertedHours,
        category,
      };

      if (editId) {
        await api.put(`/drawing-master/update/${editId}`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        alert("✅ Drawing updated");
      } else {
        await api.post("/drawing-master", payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        alert("✅ Drawing added");
      }

      resetForm();
      fetchDrawingList();
    } catch (err) {
      alert(err.response?.data?.message || "Error saving drawing");
    }
  };

  const handleEdit = (item) => {
    if (item.source === "sheet") return;
    setEditId(item._id);
    settypeofProject(item.typeofProject);
    setworkType(item.workType);
    setdrawingDocument(item.drawingDocument);
    setEstimatedHours(item.estimatedHours);
    setTimeUnit("hrs");
    setCategory(item.category);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this entry?")) {
      try {
        await api.delete(`/drawing-master/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        alert("✅ Deleted");
        fetchDrawingList();
      } catch (err) {
        alert("❌ Delete failed");
      }
    }
  };

  const resetForm = () => {
    setEditId(null);
    settypeofProject("");
    setworkType("");
    setdrawingDocument("");
    setEstimatedHours("");
    setTimeUnit("hrs");
    setCategory("ALL");
  };

  const importSheetToDB = async () => {
    try {
      const sheetRes = await fetchGoogleSheetData();
      const sheetData = sheetRes
        .filter((row) => row["Drawings & Documents"])
        .map((row) => ({
          typeofProject: row["Type of Project"] || "",
          workType: row["Work type"] || "",
          drawingDocument: row["Drawings & Documents"] || "",
          estimatedHours: row["Estimate Mins"]
            ? (parseFloat(row["Estimate Mins"]) / 60).toFixed(2)
            : "",
          category: row["Category"] || "",
        }));

      const res = await api.post(
        "/drawing-master/import-sheet",
        { data: sheetData },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      alert(res.data.message || "Sheet data imported.");
      fetchDrawingList();
    } catch (err) {
      alert("❌ Import failed");
    }
  };

  return (
    <div style={styles.container}>
      <div style={{ textAlign: "left", marginBottom: "20px" }}>
        <button onClick={() => navigate("/admin")} style={styles.backButton}>
          ← Back to Dashboard
        </button>
      </div>

      <h2 style={styles.heading}>Drawing Master</h2>

      <div style={styles.card}>
        <h3 style={styles.subHeading}>
          {editId ? "✏️ Edit Drawing" : "➕ Add New Drawing"}
        </h3>
        <div style={styles.inputRow}>
          <input
            type="text"
            value={typeofProject}
            onChange={(e) => settypeofProject(e.target.value)}
            placeholder="Type of Project"
            style={styles.input}
          />
          <input
            type="text"
            value={workType}
            onChange={(e) => setworkType(e.target.value)}
            placeholder="Work Type"
            style={styles.input}
          />
          <input
            type="text"
            value={drawingDocument}
            onChange={(e) => setdrawingDocument(e.target.value)}
            placeholder="Drawing & Document"
            style={styles.input}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="number"
              value={estimatedHours}
              onChange={(e) => setEstimatedHours(e.target.value)}
              placeholder="Est. Time"
              min="0"
              step="0.01"
              style={{ ...styles.input, width: "120px" }}
            />
            <select
              value={timeUnit}
              onChange={(e) => setTimeUnit(e.target.value)}
              style={{
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            >
              <option value="hrs">hrs</option>
              <option value="min">min</option>
            </select>
          </div>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            style={styles.select}
          >
            <option value="ALL">Select Category</option>
            <option value="USA">USA</option>
            <option value="CAD">CANADA</option>
            <option value="Arch.ind">Arch.ind</option>
            <option value="Gruda">Gruda</option>
            <option value="ProjectData">ProjectData</option>
            <option value="DC">DC</option>
            <option value="Interior">Interior</option>
            <option value="BD & M">BD & M</option>
            <option value="Finance">Finance</option>
            <option value="Sales">Sales</option>
            <option value="Marketing">Marketing</option>
          </select>
          <button onClick={handleAddDrawingMaster} style={styles.button}>
            {editId ? "Update" : "✅ Save"}
          </button>
          <button
            onClick={importSheetToDB}
            style={{ ...styles.button, backgroundColor: "#555" }}
          >
            📥 Import Sheet to DB
          </button>
        </div>
      </div>

      <div style={styles.card}>
        <h3 style={styles.subHeading}>📋 Drawing Master Table</h3>

        {/* 🔽 Category Filter for View */}
        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontWeight: "bold", marginRight: "8px" }}>
            Filter by Category:
          </label>
          <select
            value={viewCategory}
            onChange={(e) => setViewCategory(e.target.value)}
            style={{
              padding: "8px 12px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            <option value="ALL">All</option>
            <option value="USA">USA</option>
            <option value="CAD">CANADA</option>
            <option value="Arch.ind">Arch.ind</option>
            <option value="Gruda">Gruda</option>
            <option value="ProjectData">ProjectData</option>
            <option value="DC">DC</option>
            <option value="Interior">Interior</option>
            <option value="BD & M">BD & M</option>
            <option value="Finance">Finance</option>
            <option value="Sales">Sales</option>
            <option value="Marketing">Marketing</option>
          </select>
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Type of Project</th>
                <th style={styles.th}>Work Type</th>
                <th style={styles.th}>Drawing & Document</th>
                <th style={styles.th}>Est. Hours</th>
                <th style={styles.th}>Category</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {drawingList
                .filter(
                  (d) => viewCategory === "ALL" || d.category === viewCategory
                )
                .map((d) => (
                  <tr key={d._id}>
                    <td style={styles.td}>{d.typeofProject}</td>
                    <td style={styles.td}>{d.workType}</td>
                    <td style={styles.td}>{d.drawingDocument}</td>
                    <td style={styles.td}>{d.estimatedHours}</td>
                    <td style={styles.td}>{d.category}</td>
                    <td style={styles.td}>
                      {!d.source ? (
                        <>
                          <button
                            onClick={() => handleEdit(d)}
                            style={{ marginRight: 8 }}
                          >
                            ✏️
                          </button>
                          <button onClick={() => handleDelete(d._id)}>
                            🗑️
                          </button>
                        </>
                      ) : (
                        <span style={{ color: "#999" }}>Imported</span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "40px",
    backgroundColor: "#f4f6fb",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#2b3a67",
    marginBottom: "30px",
    textAlign: "center",
  },
  subHeading: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#343a76",
    marginBottom: "16px",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "24px",
    borderRadius: "12px",
    marginBottom: "30px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  },
  inputRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
  },
  input: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "14px",
    flex: "1",
    minWidth: "180px",
  },
  select: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "14px",
    minWidth: "150px",
  },
  button: {
    backgroundColor: "#343a76",
    color: "#fff",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    fontSize: "14px",
    cursor: "pointer",
  },
  backButton: {
    backgroundColor: "#999",
    color: "#fff",
    padding: "8px 14px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
    backgroundColor: "#fff",
  },
  th: {
    backgroundColor: "#343a76",
    color: "#fff",
    padding: "10px",
    textAlign: "left",
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid #e0e0e0",
  },
};

export default DrawingMaster;
